angular.module('aq.filters')
.filter('timeSinceNow', function() {
    return function(milliseconds) {
        return Math.abs(milliseconds - moment.utc().valueOf());
    }
});